import { render, staticRenderFns } from "./TheAppSideBar.vue?vue&type=template&id=461fcdfe&scoped=true&"
import script from "./TheAppSideBar.vue?vue&type=script&lang=js&"
export * from "./TheAppSideBar.vue?vue&type=script&lang=js&"
import style0 from "./TheAppSideBar.vue?vue&type=style&index=0&id=461fcdfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461fcdfe",
  null
  
)

export default component.exports